import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 10px;
  order: 1;
  position: relative;
  width: 100%;

  @media ${breakpoints.extraLarge} {
    margin-bottom: 0;
    margin-right: ${({ order }) => (order === 1 ? '80px' : '0')};
    order: ${({ order }) => order || 2};
    width: 50%;
  }
`;
